// extracted by mini-css-extract-plugin
export default {"root":"SupportChatWidget_root__LJGtw","lightMode":"SupportChatWidget_lightMode__rydy6"};